module.exports = __webpack_public_path__ + "img/com6.b4506a8c.gif";